import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import Button from '@mui/material/Button'
import * as React from 'react'

type Props = {
	onClick: () => void
	label: string
	dataTest?: string
}

// 戻る導線の共通ボタン（控えめなテキストボタン＋戻るアイコン）
const BackButton = ({ onClick, label, dataTest }: Props) => (
	<Button
		onClick={onClick}
		data-test={dataTest}
		color="inherit"
		size="small"
		startIcon={<ArrowBackIosNewIcon sx={{ fontSize: 14 }} />}
		sx={{
			color: 'text.secondary',
			textTransform: 'none',
			px: 1,
			minWidth: 0,
			'&:hover': { color: 'primary.main', bgcolor: 'action.hover' },
		}}
	>
		{label}
	</Button>
)

export default BackButton
